import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import createPersistedState from "vuex-persistedstate";
import mod_cliente from "../modules/modCliente";
import mod_agendaquery from "../modules/modAgendaGet";
import mod_agendaset from "../modules/modAgendaSet";
import mod_apiImg from "../modules/modApiImg";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ["ttArticuloAll", "mod_cliente", "drawerMovil"],
    }),
  ],
  state: {
    //objeto que almacena conjunto de subcategorias para seleccion de filtro
    disableNav: false,
    dsEstadistica: [],
    anioEstaClie: new Date()
      .toLocaleString("sv", { timeZoneName: "short" })
      .substr(0, 4),
    menudomodeco: false,
    //agenda
    idCliente: -1,
    idComponent: 1,
    GrupoClienteAgenda: -1,
    tabAgenda: 0,
    MaquinaRep: [],
    Disponible: [],
    loadingDetalleCliente: false,
    loadingSubCat: false,
    //agenda
    //peticion cliente detalle documentos
    listimgpred: [],
    peticionDocCliente: false,
    DetalleClienteAgenda: [],
    dsAgendaVisitasCombo: [],
    dsAgendaVisitas: [],
    dsAgendaVisitasDocPen: [],
    dsAgendaVisitasDocPenAll: [],
    dsAgendaVisitasDocVenAll: [],
    dsAgendaVisitasDocVen: [],
    dsAgendaVisitasPendi: [],
    dsAgendaVisitasVenci: [],
    dsAgendaVisitasDocVentas: [],
    dsAgendaVisitasDocVentasAll: [],
    ttFichaTecnica: [],
    consolidadoSubcat: [],
    dataArt: [],
    dsFactura: [],
    dsCaracteristicas: [],
    dsArticulosIndesLit: [],
    maestro: [],
    ttincarart: [],
    cancelTokenArr: [], // Cancelar la solicitud de matriz de tokens
    Carousel_items: [],
    Testimonios_items: [],
    Logs_items: [],
    countField: 1,
    FeatureArt: [],
    dataLog: [],
    pedidoMobil: [],
    ttindeslit: [],
    Pendientes: [],
    pedidoMobilDatos: [],
    checkRepuesto: false,
    AdPromo: false,
    AdPromoMsg: false,
    salirimg: false,
    ttCatalogo: [],
    tabBusqueda: null,
    msgFile: {
      status: null,
      msg: "",
    },
    filterFeature: {
      codcat: [],
      codscat: [],
    },
    filter: {
      //  query:'',
      codcat: null,
      codscat: [],
      codmarca: [],
      promo: false,
      repuesto: [],
      formato: [],
      calidad: [],
      disponible: false,
    },
    tabMovil: 0,
    tipoB: false,
    page: 1,
    BuscarOverlay: false,
    drawerMovil: false,
    BuscarOverlayA: false,
    idscat: false,
    notaExist: `Atención: Nivel de Existencia Bajo - Por favor confirmar con el Departamento de Ventas`,
    //objeto que almacena datos de dsDatosPedido
    pedDatosPedido: [], //dsDatosPedido
    pedItemsPedido: [], //ItemsPedido
    pedTotalesPedido: [], //TotalesPedido
    //objeto que almacena datos de facturas de documentos pendientes
    factDocPendientes: [], //DatosFactura
    factDocItemsFactura: [], //ItemsFactura
    //objeto cantidad min
    ttArticuloAll: [],
    //objeto que almacena las marcas de las subcategorias
    ttMarcas: [],
    //objeto que permiten almacenar datos del detalle de articulo
    Articulo: [],
    EspecifTecnica: [],
    Leerdir: false,
    Promocion: [],
    PromocionAll: [],
    PromocionArt: [],
    PromocionCombo: [],
    CodMarcaPdf: 0,
    PromocionCant: 1,
    changeCliente: false,
    changeSubcat: false,
    loadingPromo:false,
    errorPromo:null,
    DetalleArt: {
      Articulo: "",
      Cantidad: 1,
      Promo: 0,
      CantMin: 1,
      precioPromo: true,
      tipoPromo: 0,
      descuentoPromo: 0,
    },
    GrupoCli: 1,
    server: process.env.NODE_ENV === "development"
    ? `https://domolab2.domosa.com/WebDomodeco/php7.4/`
    : `${process.env.BASE_URL}php7.4/`,
    OpcCli: 1,
    Seccion: [],
    //objeto de configuracion
    tipoMoneda: 1, // [0] Bolivar | [1] Dolar
    simboloMoneda: ["Bs.", "$"],
    server_query:
      process.env.NODE_ENV === "development" ? "querydev.php" : "query.php",
    publicPath: process.env.BASE_URL,
    dirTemp:
      process.env.NODE_ENV === "development"
        ? `http://domolab2.domosa.com:8083/php7.4/`
        : `${process.env.BASE_URL}php7.4/`,
    dirJSON:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}json/`
        : `${process.env.BASE_URL}json/`,
    imgFT:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/caracteristicas/`
        : `${process.env.BASE_URL}images/caracteristicas/`,
    dirPHP:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}php7.4/`
        : `${process.env.BASE_URL}php7.4/`,
    imgPeque:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/productos/`
        : `${process.env.BASE_URL}images/productos/`,
    imgGaleria:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/productos/galeria/`
        : `${process.env.BASE_URL}images/productos/galeria/`,
    imgScat:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/subcategorias/`
        : `${process.env.BASE_URL}images/subcategorias/`,
    despieCes:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/despieces/`
        : `${process.env.BASE_URL}images/despieces/`,
    NoImg:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/productos/`
        : `${process.env.BASE_URL}images/productos/`,
    imgMarcas:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/marcas/`
        : `${process.env.BASE_URL}images/marcas/`,
    imgDetalleArt:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/Productos/Galeria/`
        : `${process.env.BASE_URL}images/Productos/Galeria/`,
    imgDetalle:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/Productos/`
        : `${process.env.BASE_URL}images/Productos/`,
    imgCarousel:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/carousel/`
        : `${process.env.BASE_URL}images/carousel/`,
    imgCat:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/categorias/`
        : `${process.env.BASE_URL}images/categorias/`,
    imgNosotros:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/nosotros/`
        : `${process.env.BASE_URL}images/nosotros/`,
    imgTestimonios:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/testimonios/`
        : `${process.env.BASE_URL}images/testimonios/`,
    imgLogo:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}images/logo/`
        : `${process.env.BASE_URL}images/logo/`,
    pathCatalogos: `${process.env.BASE_URL}images/catalogos/`,
    domoapi2_img:
      process.env.NODE_ENV === "development"
        ? `https://www.domosadecoraciones.com${process.env.BASE_URL}domoapi2/Imagen/`
        : `${process.env.BASE_URL}domoapi2/Imagen/`,
    ModelLogin: {
      usuario: "",
      clave: "",
      programa: "siga_xml",
    },
    dataUser: {
      Usuario: "invitado",
      NombreUsu: "",
      EmailUsu: "",
      TipoUsuario: "",
      Cia: 1,
      Vendedor: 0,
      Cliente: 0,
      NombreCliente: "",
      DescuentoCliente: 0.0,
      IndVerPrecios: false,
      IndVerPreciosExt: false,
      VerPrecios: [false, false],
      IndCargarPedido: false,
      IndIntranet: false,
      UsuarioSiga: "invitado",
      IndAutenticado: false,
      Nivel: 0,
      PedidosPend: 0,
      Mensaje: "",
    },
    Cliente: {
      showOpc: false,
      data: {
        Codigo: "",
        Descuento: 0,
        GrupoCliente: 0,
        Nombre: "",
        Rif: "",
        Siglas: "",
        Vendedor: "",
      },
      search: [],
      resumen: {},
    },
    Pedido: {
      data: {},
      items: [],
      promocion: [],
    },
    //informacion del cliente
    DetalleCliente: [],
    DetalleClienteBkO: [],
    DetalleClienteTrn: [],
    DetalleClientePre: [],
    DetalleClienteDif: [],
    //info distribuidor
    DetalleDistPre: [],
    //manejo de sesion
    countdown: null,
    seconds: 60, //4 horas
    expires_in: null,
    division: 0,
    departam: 0,
    categoria: 0,
    subcategoria: 0,
    mnuCategorias: [],
    SubCategorias: [],
    SubCategoriasBuscar: [],
    fecha_mes: new Date()
      .toLocaleString("sv", { timeZoneName: "short" })
      .substr(0, 7), //fecha dia
    timeLog: new Date()
      .toLocaleString("sv", { timeZoneName: "short" })
      .substr(0, 20),
    loading_cat: false,
    loading: false,
    errored: false,
    erroredData: null,
    marcaidsel: null,
    //objeto para la paginacion

    //objeto para controlar la seleccion de la subcategoria
    //en false indica que muestra el consolidado
    selectScat: false,
    btnrssicon: [
      {
        name: "Whatsapp",
        icon: "mdi-whatsapp",
        color: "#4AC959",
        href: "https://api.whatsapp.com/send?phone=584149504609",
        mostrar: true,
      },
      {
        name: "Domosa Decoraciones",
        icon: "mdi-instagram",
        color: "#FD1D1D",
        href: "https://www.instagram.com/domosadecoraciones/",
        mostrar: true,
      },

      {
        name: "Domosa Decoraciones",
        icon: "mdi-facebook",
        color: "#4267B2",
        href: "https://www.facebook.com/domosadecoraciones",
        mostrar: true,
      },
    ],
    CarOverlay: false,
    tipoFile: false,
    CarMsj: {
      Msj: "",
      Type: "",
    },
    ErrorBuscar: false,
    ErrorBuscarA: false,
  },
  getters: {
    fechaMensual: (state) => {
      let meses = [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ],
        arrayF = state.fecha_mes.split(["-"]);
      let id = parseInt(arrayF[1]) - 1;
      return meses[id];
    },
    validaTranferPrecio: (state) => {
      if (Object.entries(state.Articulo).length !== 0) {
        let nb = state.Articulo.filter(
          (x) =>
            x.TipoProd === "Maquina" &&
            x.Categoria === 1018 &&
            (x.SubCategoria === 30 || x.SubCategoria === 40)
        ).map((x) => x.Codigo);
        return nb.length;
      }
    },
    isManual: (state) => {
      let manual = [],
        xdata = [];
      if (Object.entries(state.ttindeslit).length !== 0) {
        state.ttindeslit.map(
          (x) =>
            (manual = {
              manualUser: x.ManualUsuario !== "" ? x.ManualUsuario : "*",
              manualTaller: x.ManualTaller !== "" ? x.ManualTaller : "*",
              fileDespiece: x.ArchivoDespiece !== "" ? x.ArchivoDespiece : "*",
            })
        );

        xdata = Object.assign({}, manual);
      }
      return (
        xdata.manualUser !== "*" ||
        xdata.manualTaller !== "*" ||
        xdata.fileDespiece !== "*"
      );
    },
    subcat: (state) => {
      return state.SubCategorias.filter((e) => e.SubCategoria != 0);
    },
    filterscat: (state) => {
      return state.ttArticuloAll.filter(
        (e) => e.SubCategoria === state.filter.codscat
      );
    },
    filterpromo: (state) => {
      return state.PromocionAll;
    },
    filterpromoart: (state) => {
      return state.PromocionArt;
    },

    filtersearch: (state) => {
      return state.ttArticuloAll;
    },
    filtermarca: (state) => {
      return state.ttArticuloAll.filter(
        (e) => e.Marca === state.filter.codmarca
      );
    },
    filterfeature: (state) => {
      return state.FeatureArt.filter(
        (e) =>
          (state.filterFeature.codscat.length === 0
            ? e.SubCategoria === e.SubCategoria && e.Categoria === e.Categoria
            : state.filterFeature.codscat === e.SubCategoria) &&
          (state.filterFeature.codcat.length === 0
            ? e.Categoria === e.Categoria
            : state.filterFeature.codcat === e.Categoria)
      );
    },
    filterconsolidado: (state) => {
      let arrAll = state.ttArticuloAll.filter(
        (e) =>
          (state.filter.codscat.length === 0
            ? e.SubCategoria === e.SubCategoria && e.Categoria === e.Categoria
            : state.tipoB === false
            ? state.filter.codscat === e.SubCategoria
            : state.filter.codscat === e.SubCategoria &&
              state.filter.codcat === e.Categoria) &&
          (state.filter.codmarca.length === 0
            ? e.Marca === e.Marca
            : state.filter.codmarca.indexOf(e.Marca) >= 0) &&
          (state.filter.formato.length === 0
            ? e.Formato === e.Formato
            : state.filter.formato.indexOf(e.Formato) >= 0) &&
          (state.filter.calidad.length === 0
            ? e.Calidad === e.Calidad
            : state.filter.calidad.indexOf(e.Calidad) >= 0) &&
          (state.filter.repuesto.length === 0
            ? e.TipoProd === e.TipoProd
            : state.filter.repuesto === e.TipoProd) &&
          (state.filter.disponible === false
            ? e.Disponible === e.Disponible
            :  e.Disponible !== 0) && 
          (state.filter.promo === false
            ? e.Promocion === e.Promocion
            : state.filter.promo === e.Promocion)
      );

      localStorage.setItem("datosgrid", JSON.stringify(arrAll));
      return arrAll;
    },
  },
  mutations: {
    set_idComponente(state) {
      state.idComponent++;
    },
    SET_DISPONIBLE(state) {
      state.filter.disponible = !state.filter.disponible
    },
    CLR_DISPONIBLE(state) {
      state.filter.disponible = false;
    },
    setCountField(state, value) {
      state.countField += value;
    },
    setErrorPromo(state, payload) {
      state.errorPromo = payload;
    },
    setLoadingPromo(state, payload) {
      state.loadingPromo = payload;
    },
    setTabAgenda(state, payload) {
      state.tabAgenda = payload;
    },
    setListimgpred(state, payload) {
      state.listimgpred = payload;
    },
    setTtFichaTecnica(state, payload) {
      state.ttFichaTecnica.push(payload);
    },
    clrTtFichaTecnica(state) {
      state.ttFichaTecnica = [];
    },
    setTabMovil(state, payload) {
      state.tabMovil = payload;
    },
    set_tipoB(state, data) {
      state.tipoB = data;
    },
    set_peticionDocCliente(state, data) {
      state.peticionDocCliente = data;
    },
    clr_ttindeslit(state) {
      state.ttindeslit = [];
    },
    set_ttindeslit(state, data) {
      state.ttindeslit = data;
    },
    set_disableNav(state, data) {
      state.disableNav = data;
    },
    set_dsArticulosIndesLit(state, data) {
      state.dsArticulosIndesLit = data;
    },
    set_Maestro(state, data) {
      state.maestro = data;
    },
    set_dataLog(state, data) {
      state.dataLog = data;
    },
    set_dsCaracteristicas(state, data) {
      state.dsCaracteristicas = data;
    },
    pushToken(state, payload) {
      state.cancelTokenArr.push(payload.cancelToken);
    },
    clearToken({ cancelTokenArr }) {
      cancelTokenArr.forEach((item) => {
        item("Solicitud http Cancelada");
      });
      cancelTokenArr = [];
    },
    clr_Testimonios_items(state) {
      state.Testimonios_items = [];
    },
    clr_Logs_items(state) {
      state.Logs_items = [];
    },
    set_Logs_items(state, data) {
      state.Logs_items.push(data);
    },
    set_Testimonios_items(state, data) {
      state.Testimonios_items.push(data);
    },
    clr_Carousel_items(state) {
      state.Carousel_items = [];
    },
    set_Carousel_items(state, data) {
      state.Carousel_items.push(data);
    },
    set_tabBusqueda(state, data) {
      state.tabBusqueda = data;
    },
    set_page(state) {
      state.page = state.page + 1;
      window.localStorage.setItem("pagart", JSON.stringify(state.page));
    },
    minus_page(state) {
      state.page = state.page - 1;
      window.localStorage.setItem("pagart", JSON.stringify(state.page));
    },
    clr_page(state) {
      state.page = 1;
    },
    set_salirimg(state) {
      state.salirimg = false;
    },
    set_salirimgt(state) {
      state.salirimg = true;
    },
    CLR_PEDIDO(state) {
      state.pedDatosPedido = [];
      state.pedItemsPedido = [];
      state.pedTotalesPedido = [];
    },
    set_AdPromoMsg(state, data) {
      state.AdPromoMsg = data;
    },
    set_AdPromoF(state) {
      state.AdPromo = false;
    },
    set_AdPromoT(state) {
      state.AdPromo = true;
    },
    set_idscatF(state) {
      state.idscat = false;
    },
    set_idscatT(state) {
      state.idscat = true;
    },
    set_Countdown(state, data) {
      state.countdown = data;
    },
    set_checkRepuesto(state) {
      state.checkRepuesto = !state.checkRepuesto;
    },
    set_checkRepuestoF(state) {
      state.checkRepuesto = false;
    },
    set_pedidoMobil(state, data) {
      state.pedidoMobil = data;
    },
    set_pedidoMobilDatos(state, data) {
      state.pedidoMobilDatos = data;
    },
    set_changeSubcat(state) {
      state.changeSubcat = true;
    },
    set_changeSubcatF(state) {
      state.changeSubcat = false;
    },
    set_changeCliente(state) {
      state.changeCliente = !state.changeCliente;
    },
    set_expires_in(state, data) {
      state.expires_in = data;
    },
    set_expires_inM(state) {
      state.expires_in -= 1;
    },
    set_expires_inP(state) {
      state.expires_in = state.expires_in * 1000;
    },
    clr_msgFile(state) {
      state.msgFile = {
        status: null,
        msg: "",
      };
    },
    set_msgFile(state, data) {
      state.msgFile = data;
    },
    set_DetalleArt(state, data) {
      state.DetalleArt = data;
    },
    set_CodMarcaPdf(state, data) {
      state.CodMarcaPdf = data;
    },
    set_BuscarOverlay(state, data) {
      state.BuscarOverlay = data;
    },
    set_BuscarOverlayA(state, data) {
      state.BuscarOverlayA = data;
    },
    set_Dir(state) {
      state.Leerdir = state.Leerdir ? false : true;
    },
    incrementar(state, index) {
      state.PromocionAll[index].Cantidad++;
    },
    increment(state) {
      state.DetalleArt.Cantidad++;
    },
    decrement(state) {
      state.DetalleArt.Cantidad--;
    },
    set_ModelLogin(state, model) {
      state.ModelLogin = model;
    },
    set_dataUser(state, data) {
      state.dataUser = data;
    },
    setDrawerMovil(state, payload) {
      state.drawerMovil = payload;
    },
    CRL_DetalleCliente(state) {
      state.DetalleCliente = [];
    },
    CRL_DetalleClienteBkO(state) {
      state.DetalleClienteBkO = [];
    },
    CRL_DetalleClienteTrn(state) {
      state.DetalleClienteTrn = [];
    },
    CRL_DetalleClientePre(state) {
      state.DetalleClientePre = [];
    },
    CRL_DetalleClienteDif(state) {
      state.DetalleClienteDif = [];
    },
    clr_dsEstadistica(state) {
      state.dsEstadistica = [];
    },
    setMenuDomoDeco(state, payload) {
      state.menudomodeco = payload;
    },
    set_dsEstadistica(state, data) {
      state.dsEstadistica = data;
    },
    set_anioEstaClie(state, data) {
      state.anioEstaClie = data
    },
    set_DetalleCliente(state, data) {
      state.DetalleCliente = data;
    },
    set_DetalleClienteBkO(state, data) {
      state.DetalleClienteBkO = data;
    },
    set_DetalleDistPre(state, data) {
      state.DetalleDistPre = data;
    },
    clr_DetalleDistPre(state) {
      state.DetalleDistPre = [];
    },
    set_DetalleClienteTrn(state, data) {
      state.DetalleClienteTrn = data;
    },
    set_DetalleClientePre(state, data) {
      state.DetalleClientePre = data;
    },
    set_DetalleClienteDif(state, data) {
      state.DetalleClienteDif = data;
    },
    set_Cliente(state, data) {
      state.Cliente = data;
      window.sessionStorage.setItem("cliente", JSON.stringify(data));
    },
    set_Pedido(state, data) {
      state.Pedido = data;
    },
    set_loading_cat(state, load) {
      state.loading_cat = load;
    },
    set_loading(state, load) {
      state.loading = load;
    },
    set_mnuCategorias(state, data) {
      state.mnuCategorias = data.filter((x) => x.SubCategoria == 0);
    },
    set_subcategoria(state, data) {
      state.subcategoria = data;
    },
    set_SubCategorias(state, data) {
      state.SubCategorias = data;
    },
    set_SubCategoriasBuscar(state, data) {
      state.SubCategoriasBuscar = data;
    },
    set_ttCatalogo(state, data) {
      state.ttCatalogo = data;
    },
    set_varCategorias(state, [div, dep, cat]) {
      state.division = div;
      state.departam = dep;
      state.categoria = cat;
    },
    set_BotonRSS(state, data) {
      state.btnrssicon = data;
    },
    SELECTSCAT(state) {
      state.selectScat != state.selectScat;
    },
    //filtro feature
    get_featuresubcat(state, payload) {
      state.filterFeature.codscat = payload;
    },
    get_featurecat(state, payload) {
      state.filterFeature.codcat = payload;
    },
    clr_features(state) {
      state.filterFeature.codscat = [];
      state.filterFeature.codcat = [];
    },
    //filtro grid
    GET_BUSCARSCAT(state, payload) {
      state.filter.codscat = payload;
    },
    GET_BUSCARCAT(state, payload) {
      state.filter.codcat = payload;
    },
    GET_BUSCAR(state, payload) {
      state.filter.query = payload;
    },
    GET_PRECIO1(state, payload) {
      state.filter.preciomin = payload;
    },
    GET_PRECIO2(state, payload) {
      state.filter.preciomax = payload;
    },
    GET_PRECIOALL(state, payload) {
      state.filter.preciomin = payload.min;
      state.filter.preciomax = payload.max;
    },
    GET_BUSCARMARCA(state, payload) {
      state.filter.codmarca = payload;
    },
    GET_BUSCARCALIDAD(state, payload) {
      state.filter.calidad = payload;
    },
    CLR_BUSCARCALIDAD(state) {
      state.filter.calidad = [];
    },
    GET_BUSCARFORMATO(state, payload) {
      state.filter.formato = payload;
    },
    CLR_BUSCARFORMATO(state) {
      state.filter.formato = [];
    },
    GET_BUSCAREPUESTO(state, payload) {
      state.filter.repuesto = payload;
    },
    CLR_BUSCAREPUESTO(state) {
      state.filter.repuesto = [];
    },
    setDisponible(state) {
      state.filter.disponible = !state.filter.disponible;
    },
    clrDisponible(state) {
      state.filter.disponible = false;
    },
    GET_BUSCARPROMO(state) {
      state.filter.promo = !state.filter.promo;
    },
    CLR_BUSCARPROMO(state) {
      state.filter.promo = false;
    },
    CLR_BUSCARSCAT(state) {
      state.filter.codscat = [];
    },
    CLR_BUSCARCAT(state) {
      state.filter.codcat = [];
    },
    CLR_PROMO(state) {
      state.PromocionAll = [];
    },
    CLR_CodMarcaPdf(state) {
      state.CodMarcaPdf = 0;
    },
    CLR_BUSCARSCATall(state) {
      state.SubCategorias = [];
    },
    CLR_BUSCARMARCA(state) {
      state.filter.codmarca = [];
    },
    CLR_BUSCARMARCAtt(state) {
      state.ttMarcas = [];
    },
    CLR_PRECIO(state) {
      state.filter.preciomin = null;
      state.filter.preciomax = null;
    },
    CLR_BUSCARQUERY(state) {
      state.filter.query = "";
    },
    SET_DATOS_SUBCAT_ARRAY(state, { datos }) {
      state.consolidadoSubcat.push(datos);
    },
    SET_DATOS_SUBCAT_ALL(state, payload) {
      state.ttArticuloAll = payload;
    },
    SET_QUERY_PDF(state, payload) {
      state.filterPdf.codmarca = payload;
    },
    CLR_DATOS_SUBCATB(state) {
      state.SubCategoriasBuscar = [];
    },
    CLR_DATOS_SUBCAT(state) {
      state.ttArticuloAll = [];
      state.SubCategorias = [];
    },
    CLR_ERROR_AXIOS(state) {
      state.errored = false;
      state.erroredData = null;
    },
    ERROR_AXIOS(state) {
      state.errored = true;
    },
    ERROR_DATA(state, payload) {
      state.erroredData = payload;
    },
    setLoadingSubCat(state, payload) {
      state.loadingSubCat = payload;
    },
    setLoadingDetalleCliente(state, payload) {
      state.loadingDetalleCliente = payload;
    },
    SET_DATOS_SUBCAT_MARCA(state, payload) {
      state.ttMarcas = payload;
    },
    SET_MARCA_FILTER(state, payload) {
      state.marcaidsel = payload;
    },
    //mutacion que llena el state de Articulo
    SET_DATOS_ART(state, payload) {
      state.Articulo = payload;
    },
    set_FeatureArt(state, payload) {
      state.FeatureArt = payload;
    },
    set_ttincarart(state, payload) {
      state.ttincarart = payload;
    },
    clr_FeatureArt(state) {
      state.FeatureArt = [];
    },
    CLR_DATOS_ART(state) {
      state.Articulo = [];
    },
    //mutacion que llena el state de ficha tecnica (Ficha tecnica)
    SET_DATOS_ART_ET(state, payload) {
      state.EspecifTecnica = payload;
    },
    CLR_DATOS_ART_ET(state) {
      state.EspecifTecnica = [];
    },
    setMaquinaRep(state, payload) {
      state.MaquinaRep = payload;
    },
    setDisponible(state, payload) {
      state.Disponible = payload;
    },
    clrMaquinaRep(state) {
      state.MaquinaRep = [];
    },
    //mutacion que llena el state de repuestos del articulo (Repuestos)
    SET_DATOS_ART_SEC(state, payload) {
      state.Seccion = payload;
    },
    CLR_DATOS_ART_SEC(state) {
      state.Seccion = [];
    },
    //mutacion que llena el state de promociones del articulo (Promociones)
    SET_DATOS_ART_PROM(state, payload) {
      state.Promocion = payload;
    },
    set_PromocionArt(state, payload) {
      state.PromocionArt = payload;
    },
    SET_DATOS_ART_PROM_ALL(state, payload) {
      state.PromocionAll = payload;
    },
    SET_DATOS_ART_PROM_COMBO(state, payload) {
      state.PromocionCombo = payload;
    },
    set_GrupoCli(state, data) {
      state.GrupoCli = data;
    },
    set_OpcCli(state, data) {
      state.OpcCli = data;
    },
    clr_OpcCli(state) {
      state.OpcCli = 1;
    },
    set_tipoFile(state) {
      state.tipoFile = !state.tipoFile;
    },
    set_mensaje(state, data) {
      state.CarOverlay = data.Visible;
      state.CarMsj = {
        Msj: data.Msj,
        Type: data.Type,
      };
    },
    SET_DATOS_ART_PROMO_CANT(state, payload) {
      state.PromocionCant = payload;
    },
    set_Pendientes(state, data) {
      state.Pendientes = data;
    },
    //pedido tipo de documento 14
    set_pedDatosPedido(state, payload) {
      state.pedDatosPedido = payload;
    },
    set_pedItemsPedido(state, payload) {
      state.pedItemsPedido = payload;
    },
    set_pedTotalesPedido(state, payload) {
      state.pedTotalesPedido = payload;
    },
    setFactura(state, payload) {
      state.dsFactura = [];
      state.dsFactura = payload;
    },
    //factura tipo de documento 30
    SET_FACTDOC_PENDIENTES(state, payload) {
      state.factDocPendientes = payload;
    },
    SET_ITEMSFACTDOC_PENDIENTES(state, payload) {
      state.factDocItemsFactura = payload;
    },
    CLR_ITEMSFACTDOC_PENDIENTES(state) {
      state.factDocItemsFactura = [];
    },
    CLR_FACTDOC_PENDIENTES(state) {
      state.factDocPendientes = [];
    },
    // Error al buscar
    set_ErrorBuscar(state, data) {
      state.ErrorBuscar = data;
    },
    set_ErrorBuscarA(state, data) {
      state.ErrorBuscarA = data;
    },
  },
  actions: {
    facturaDocPendiente: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "DatosFacturaJSON",
              usuario: state.dataUser.Usuario,
              nd: id.NumeroDoc,
              td: id.TipoDoc,
              op: 1,
            },
          }
        );
        const { data: { dsDatosPedido, dsFactura, dsPedidoConfirmado }} = respuesta
        if (dsFactura) {          
          const { DatosFactura, ItemsFactura } = dsFactura
          commit("setFactura", dsFactura);
          commit("SET_FACTDOC_PENDIENTES", DatosFactura);
          commit("SET_ITEMSFACTDOC_PENDIENTES", ItemsFactura);
        }
        if (dsDatosPedido) {
          const { DatosPedido, ItemsPedido, TotalesPedido } = dsDatosPedido
          commit("setFactura", dsDatosPedido);
          commit("set_pedDatosPedido", DatosPedido);
          if (ItemsPedido)
            commit("set_pedItemsPedido", ItemsPedido);
          if (TotalesPedido)
            commit("set_pedTotalesPedido", TotalesPedido);
        }
        if (dsPedidoConfirmado) {
          const { DatosConfirmado, ItemsConfirmado } = dsPedidoConfirmado
          commit("setFactura", dsPedidoConfirmado);
          commit("set_pedDatosPedido", DatosConfirmado);
          if (ItemsConfirmado)
            commit("set_pedItemsPedido", ItemsConfirmado);
        }
      } catch (error) {
        console.log(error);
        commit("ERROR_AXIOS");
      }
    },
    cargarDatosPromoCombo: async ({ state, commit }, id) => {
      try {
        await axios
          .get(`${state.dirPHP}${state.server_query}`, {
            params: {
              program: "promocionesjson",
              usuario: state.dataUser.Usuario,
              codigopromo: id.CodigoPromo,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              json: 1,
            },
          })
          .then(function (response) {
            
            commit(
              "SET_DATOS_ART_PROM_COMBO",
              response.data.dsPromociones.wfmovpaq
            );

          });
      } catch (error) {
        console.log(error);
      }
    },
    cargarImg: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CatalogoWebJson",
              articulo: id.articulo,
              usuario: state.dataUser.Usuario,
              imagen: id.imagen,
              cia: 1,
              opc: 3,
            },
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    cargarLog: async ({ state }) => {
      try {
        let URL = `${state.dirPHP}addlog.php`;
        let params = JSON.stringify({
          log: state.dataLog,
        });
        await axios.post(URL, params, {
          headers: { "Content-Type": "application/json" },
        });
      } catch (error) {
        console.log(error);
      }
    },
    cargarCatalogoWeb: async ({ state, commit }, id) => {
      try {
        commit("set_loading", true);
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CatalogoWebJson",
              usuario: state.dataUser.Usuario,
              articulo: id.articulo,
              div: id.div,
              dep: id.dep,
              cat: id.cat,
              sub: id.sub,
              opc: 1,
            },
          }
        );
        let status = respuesta.status;
        if (status == 200) {
          let data = await respuesta.data;

          let ttindeslit = await data.ttindeslit;

          commit("set_ttindeslit", ttindeslit);
          commit("set_loading", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarIndesLit: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "BuscaProductoJson",
              usuario: state.dataUser.Usuario,
              buscar: id.buscar,
              marca: id.marca,
              tipopro: id.tipopro,
              opc: 1,
            },
          }
        );
        let data = await respuesta.data;

        let dsArticulosAll = await data.dsArticulosAll;

        commit("set_dsArticulosIndesLit", dsArticulosAll);
        commit("set_BuscarOverlay", false);
      } catch (error) {
        console.log(error);
      }
    },
    cargarMaestro: async ({ state, commit }) => {
      const { dirPHP, server_query, dataUser } = state;
      const params = {
        program: "CategoriaJson",
        usuario: dataUser.Usuario,
        div: 0,
        dep: 0,
        cat: 0,
        opc: 2,
      };

      try {
        const {
          data: { dsCategorias },
        } = await axios.get(`${dirPHP}${server_query}`, { params });
        if (dsCategorias) commit("set_Maestro", dsCategorias);
        else commit("set_Maestro", null);
      } catch (error) {
        console.error(error);
      }
    },
    cargarFile: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CatalogoWebJson",
              usuario: state.dataUser.Usuario,
              articulo: id.articulo,
              musuario: id.musuario,
              mtaller: id.mtaller,
              despiece: id.despiece,
              cia: id.cia,
              opc: id.opc,
            },
          }
        );
        let status = respuesta.status;
        if (status == 200) {
          let data = await respuesta.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarFeature: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CaracteristicaJson",
              codigo: id.codigo,
              titulo: id.titulo,
              contenido: id.contenido,
              imagen: id.imagen,
              orden: id.orden,
              link: id.link,
              status: id.status,
              articulo: id.articulo,
              cia: id.cia,
              div: id.div,
              cat: id.cat,
              dep: id.dep,
              sub: id.sub,
              opc: id.opc,
            },
          }
        );
        let data = await respuesta.data;
        let ttinmaecar = await (data.ttinmaecar ? data.ttinmaecar : null);
        let ttincarart = await (data.ttincarart ? data.ttincarart : null);
        let dsCaracteristicas = await (data.dsCaracteristicas
          ? data.dsCaracteristicas
          : null);

        if (id.opc === 2) commit("set_FeatureArt", ttinmaecar);
        if (id.opc === 5) commit("set_ttincarart", ttincarart);
        if (id.opc === 8) commit("set_dsCaracteristicas", dsCaracteristicas);
      } catch (error) {
        console.log(error);
      }
    },
    cargarDatosPromo: async ({ state, commit }, id) => {
      try {
        await axios
          .get(`${state.dirPHP}${state.server_query}`, {
            params: {
              program: "promociones",
              usuario: state.dataUser.Usuario,
              articulo: id.codart,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              json: 1,
            },
          })
          .then((resp) => {
            const { data: { dsPromociones: { wfmaepaq } } } = resp
            commit("SET_DATOS_ART_PROM_ALL", wfmaepaq);
            commit("set_PromocionArt", wfmaepaq);
          });
      } catch (error) {
        console.log(error);
      }
    },
    datosFichaTec: async ({ state, commit }, id) => {
      try {
        await axios
          .get(`${state.dirPHP}${state.server_query}`, {
            params: {
              program: "productojson",
              usuario: state.dataUser.Usuario,
              articulo: id.codart,
              cliente: 0,
            },
          })
          .then(function (response) {
            const {
              data: {
                dsCompleto: { EspecifTecnica },
              },
            } = response;

            if (EspecifTecnica !== undefined)
              commit("setTtFichaTecnica", EspecifTecnica);
          });
      } catch (error) {
        console.log(error);
      }
    },
    cargarDatosArt: ({ state, commit }, id) => {
      try {
        commit("clrMaquinaRep")
        commit("CLR_DATOS_ART_SEC")
        commit("CLR_DATOS_ART")
        commit("CLR_DATOS_ART_ET")
        axios
          .get(`${state.dirPHP}${state.server_query}`, {
            params: {
              program: "productojson",
              usuario: state.dataUser.Usuario,
              articulo: id.codart,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
            },
          })
          .then((resp) => {
            const {
              data: {
                dsCompleto: { articulo, EspecifTecnica, Seccion, Maquina, Promocion, Disponible },
              },
            } = resp
            
            if (articulo) commit("SET_DATOS_ART", articulo)
            if (EspecifTecnica) commit("SET_DATOS_ART_ET", EspecifTecnica)
            if (Seccion) commit("SET_DATOS_ART_SEC", Seccion)
            if (Maquina) commit("setMaquinaRep", Maquina);
            if (Disponible) commit("setDisponible", Disponible)
            else commit("setDisponible", [])
          });
      } catch (error) {
        console.log(error);
      }
    },

     cargarDatosArtCar: async ({ state, commit }, id) => {
      try {
        const queryParams = new URLSearchParams({
              program: "productojson",
              usuario: state.dataUser.Usuario,
              articulo: id.codart,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
            });

        commit("setLoadingPromo", true);
        const res = await fetch(
          `${state.dirPHP}${state.server_query}?${queryParams}`,
          { method: "GET" }
        );
        if (!res.ok) {
          throw new Error(`Error en la petición Fetch: ${res.status}`);
        }

        const jsonData = await res.json();
        const { dsCompleto, dsCompleto:{StatusJSon}} = jsonData
        const [{ Procesado, Notas }] = StatusJSon;
         
        if(Procesado){
           const { articulo} = dsCompleto
           commit("SET_DATOS_ART", articulo);
        }else{
          commit("setErrorPromo", Notas);
        }
       
        commit("setLoadingPromo", false);  
        
      } catch (error) {
        console.error(error);
      } 
    },
    cargarDatosMarcaCat: async ({ state, commit }) => {
      try {
        await axios
          .get(`${state.dirPHP}${state.server_query}`, {
            params: {
              program: "CategoriaJson",
              usuario: state.dataUser.Usuario,
              div: state.division,
              dep: state.departam,
              cat: state.categoria,
              opc: 0,
            },
          })
          .then(function (response) {
            commit(
              "SET_DATOS_SUBCAT_MARCA",
              response.data.dsCategorias.ttMarcas
            );
          });
      } catch (error) {
        console.log(error);
      }
    },
    consolidadoSCategoria: async ({ state, commit }, id) => {
      try {
        const queryParams = new URLSearchParams({
          program: "ListaProdJson",
          usuario: state.dataUser.Usuario,
          div: state.division,
          dep: state.departam,
          cat: state.categoria,
          subcat: state.subcategoria,
          marca: 0,
          cliente: state.Cliente.data.Codigo ? state.Cliente.data.Codigo : 0,
        });

        commit("setLoadingSubCat", true);
        const res = await fetch(
          `${state.dirPHP}${state.server_query}?${queryParams}`,
          {
            method: "GET",
            signal: id.signal,
          }
        );
        if (!res.ok) {
          throw new Error(`Error en la petición Fetch: ${res.status}`);
        }

        const jsonData = await res.json();
        if (!id.signal.aborted) {
          const {
            dsArticulosAll: { ttCategoria, ttArticulo, wfmaepaq, ttMarcas },
          } = jsonData;
          commit("set_SubCategorias", ttCategoria);
          commit("SET_DATOS_SUBCAT_ALL", ttArticulo);
          commit("SET_DATOS_ART_PROM_ALL", wfmaepaq);
          commit("SET_DATOS_SUBCAT_MARCA", ttMarcas);
          commit("setLoadingSubCat", false);
          wfmaepaq && window.sessionStorage.setItem("wfmaepaq", JSON.stringify(wfmaepaq));
        }
      } catch (error) {
        console.error(error);
      } 
    },
    consolidadoSCategoriaCar: async ({ state, commit }, id) => {
      try {
        await axios
          .get(`${state.dirPHP}${state.server_query}`, {
            params: {
              program: "ListaProdJson",
              usuario: state.dataUser.Usuario,
              div: state.division,
              dep: state.departam,
              cat: state.categoria,
              subcat: 0,
              marca: 0,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
            },
          })
          .then(function (response) {
            if (response.data.dsArticulosAll.ttArticulo.length > 0) {
              commit(
                "SET_DATOS_SUBCAT_ALL",
                response.data.dsArticulosAll.ttArticulo
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    get_rss: async ({ state, commit }) => {
      try {
        let respuesta = await axios(`${path}/json/rss.json`);
        let data = await respuesta.data;
        commit("set_BotonRSS", data);
      } catch (error) {
        console.log(error);
      }
    },
    get_mnuCategorias: async ({ state, commit }) => {
      commit("set_loading_cat", true);
      try {
        let respuesta = await axios(`${state.dirPHP}${state.server_query}`, {
          params: {
            program: "CategoriaJson",
            usuario: "invitado",
            div: 0,
            dep: 0,
            cat: 0,
            opc: 0,
          },
        });
        let data_cat = await respuesta.data;
        let dsCategorias = await data_cat.dsCategorias;
        let ttCategoria = await dsCategorias.ttCategoria;

        commit("set_mnuCategorias", ttCategoria);
      } catch (error) {
        console.log(error);
      }
      commit("set_loading_cat", false);
    },
    get_SubCategorias: async ({ state, commit }, id) => {
      commit("set_loading", true);
      try {
        let respuesta = await axios(`${state.dirPHP}${state.server_query}`, {
          params: {
            program: "CategoriaJson",
            usuario: "invitado",
            div: state.division,
            dep: state.departam,
            cat: state.categoria,
            opc: 0,
          },
        });
        let data_cat = await respuesta.data;
        let dsCategorias = await data_cat.dsCategorias;
        let ttCategoria = await dsCategorias.ttCategoria;

        commit("set_SubCategorias", ttCategoria);
      } catch (error) {
        console.log(error);
      }
      commit("set_loading", false);
    },
    get_Autenticacion: async ({ state, dispatch, commit }) => {
      let xLogin = state.ModelLogin;
      let respuesta = await axios(`${state.dirPHP}${state.server_query}`, {
        params: {
          program: "ValidaUsuarioJson",
          usuario: xLogin.usuario,
          clave: window.btoa(xLogin.clave),
          programa: xLogin.programa,
          json: 1,
        },
      });
      let data = await respuesta.data;

      commit("set_dataUser", data.wfusuario[0]);
      window.sessionStorage.setItem("datauser", JSON.stringify(state.dataUser));

      if (state.dataUser.TipoUsuario == "C") {
        commit("set_Cliente", {
          showOpc: false,
          data: {
            Codigo: state.dataUser.Cliente,
            Descuento: state.dataUser.DescuentoCliente,
            GrupoCliente: state.dataUser.GrupoCliente,
            Nombre: state.dataUser.NombreCliente,
            Rif: state.dataUser.Rif,
            Siglas: state.dataUser.Siglas,
            Vendedor: state.dataUser.Vendedor,
          },
          search: [],
          resumen: {},
        });
        await dispatch("get_ResumenCliente");
        await dispatch("get_ConsultaPedido");
      } else {
        commit("set_Cliente", {
          showOpc: true,
          data: {
            Codigo: "",
            Descuento: 0,
            GrupoCliente: 0,
            Nombre: "",
            Rif: "",
            Siglas: "",
            Vendedor: "",
          },
          search: [],
          resumen: {},
        });
      }
    },
    get_BuscaClientes: async ({ state, commit }, txtCliente) => {
      if (txtCliente.length > 1) {
        commit("set_loading", true);

        let respuesta = await axios(`${state.dirPHP}${state.server_query}`, {
          params: {
            program: "ListaClienteJson",
            usuario: state.dataUser.Usuario,
            buscar: txtCliente,
          },
        });
        let data = await respuesta.data;

        commit("set_Cliente", {
          showOpc: state.Cliente.showOpc,
          data: state.Cliente.data,
          search: data.ttcliente,
          resumen: state.Cliente.resumen,
        });
        commit("set_loading", false);
      } else {
        commit("set_Cliente", {
          showOpc: state.Cliente.showOpc,
          data: state.Cliente.data,
          search: [],
          resumen: state.Cliente.resumen,
        });
      }
    },
    get_DetalleDistDoc: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "ConsultaPedidosJson",
              usuario: state.dataUser.Usuario,
              agenda: id.agenda,
              vendedor: id.vendedor,
              opc: id.opc,
            },
          }
        );
        let data = await respuesta.data;
        let wfpedido = await data.wfpedido;

        commit("set_DetalleDistPre", wfpedido);
      } catch (error) {
        console.log(error);
      }
    },
    async get_DetalleClienteDoc({ state, commit }, id) {
      try {
        const queryParams = new URLSearchParams({
          program: "ConsultaPedidosJson",
          usuario: state.dataUser.Usuario,
          vergrupo: state.GrupoCli,
          cliente: id.cliente,
          opc: state.OpcCli,
        });
        commit("setLoadingDetalleCliente", true);
        const res = await fetch(
          `${state.dirPHP}${state.server_query}?${queryParams}`,
          {
            method: "GET",
            signal: id.signal,
          }
        );

        if (!res.ok) {
          throw new Error(`Error en la petición Fetch: ${res.status}`);
        }

        const jsonData = await res.json();

        if (!id.signal.aborted) {
          let defCommit = {
            1: `set_DetalleClienteTrn`,
            2: `set_DetalleClienteDif`,
            4: `set_DetalleClientePre`,
            5: `set_DetalleClienteBkO`,
          };

          commit(defCommit[state.OpcCli], jsonData);
        }
      } catch (error) {
        console.error(error);
      } finally {
        commit("setLoadingDetalleCliente", false);
      }
    },

    get_dsEstadistica: async ({ state, commit }, id) => {
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "ConsultaClienteJson",
              usuario: state.dataUser.Usuario,
              vergrupo: id.vergrupo,
              cliente: state.Cliente.data.Codigo,
              opc: id.opc,
              anio: id.anio,
            },
          }
        );
        let data = await respuesta.data;

        commit("set_dsEstadistica", data);
      } catch (error) {
        console.log(error);
      }
    },
    get_DetalleCliente: async ({ state, commit }) => {
      try {
        commit("set_peticionDocCliente", true);

        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "ConsultaClienteJson",
              usuario: state.dataUser.Usuario,
              vergrupo: state.GrupoCli,
              cliente: state.Cliente.data.Codigo,
              opc: state.OpcCli,
            },
          }
        );
        let data = await respuesta.data;
        commit("set_peticionDocCliente", false);
        commit("set_DetalleCliente", data);
      } catch (error) {
        console.log(error);
      }
    },
    get_ResumenCliente: async ({ state, commit }) => {
      try {
        let respuesta = await axios(`${state.dirPHP}${state.server_query}`, {
          params: {
            program: "ConsultaClienteJson",
            usuario: state.dataUser.Usuario,
            vergrupo: state.Cliente.data.GrupoCliente,
            cliente: state.Cliente.data.Codigo,
            opc: 1,
          },
        });
        let data = await respuesta.data;
        let ttResumen = await data.ttResumen[0];

        commit("set_Cliente", {
          showOpc: state.Cliente.showOpc,
          data: state.Cliente.data,
          search: [],
          resumen: ttResumen,
        });
      } catch (error) {
        console.log(error);
      }
    },
    get_BuscaArticulo: async ({ state, commit }, txtArticulo) => {
      let responsePromise = [];
      try {
        let respuesta = axios.get(`${state.dirPHP}${state.server_query}`, {
          params: {
            program: "BuscaProductoJson",
            usuario: state.dataUser.Usuario,
            buscar: txtArticulo,
            marca: 0,
            cliente: state.Cliente.data.Codigo ? state.Cliente.data.Codigo : 0,
          },
        });
        responsePromise.push(respuesta);
        let responses = await Promise.all(responsePromise);
        if (responses[0].status == 200) {
          let dataP = responses[0].data;
          if (Object.entries(dataP.dsArticulosAll.ttArticulo).length !== 0) {
            commit("CLR_DATOS_SUBCATB");
            commit("CLR_DATOS_SUBCAT");
            commit("CLR_BUSCARSCAT");
            commit("CLR_BUSCARMARCA");
            commit("CLR_BUSCARMARCAtt");
            const {
              dsArticulosAll: {
                ttCategoria,
                ttMarcas,
                ttArticulo,
                wfmaepaq,
                ttCatalogo,
              },
            } = dataP;

            commit("set_BuscarOverlay", false);
            commit("set_SubCategoriasBuscar", ttCategoria);
            commit("set_ttCatalogo", ttCatalogo);
            commit("SET_DATOS_SUBCAT_MARCA", ttMarcas);
            commit("SET_DATOS_SUBCAT_ALL", ttArticulo);
            commit("SET_DATOS_ART_PROM_ALL", wfmaepaq);
            commit("set_ErrorBuscar", false);
            return true;
          }
        } else {
          commit("set_ErrorBuscar", true);
          commit("set_BuscarOverlay", true);
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    get_BuscaArticuloMant: async ({ state, commit }, txtArticulo) => {
      let ttCategoria = [];
      let ttMarcas = [];
      let ttArticulo = [];
      let wfmaepaq = [];
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "BuscaProductoJson",
              usuario: state.dataUser.Usuario,
              buscar: txtArticulo,
              marca: 0,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
            },
          }
        );
        let data = await respuesta.data;

        if (data.dsArticulosAll.ttArticulo.length !== 0) {
          commit("CLR_DATOS_SUBCATB");
          commit("CLR_DATOS_SUBCAT");
          commit("CLR_BUSCARSCAT");
          commit("CLR_BUSCARMARCA");
          commit("CLR_BUSCARMARCAtt");

          ttCategoria = await data.dsArticulosAll.ttCategoria;
          ttMarcas = await data.dsArticulosAll.ttMarcas;
          ttArticulo = await data.dsArticulosAll.ttArticulo;
          wfmaepaq = await data.dsArticulosAll.wfmaepaq;

          commit("set_BuscarOverlayA", false);
          commit("set_SubCategoriasBuscar", ttCategoria);
          commit("SET_DATOS_SUBCAT_MARCA", ttMarcas);
          commit("SET_DATOS_SUBCAT_ALL", ttArticulo);
          commit("SET_DATOS_ART_PROM_ALL", wfmaepaq);
          commit("set_ErrorBuscarA", false);
          return true;
        } else {
          commit("set_ErrorBuscarA", true);
          commit("set_BuscarOverlayA", true);
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },
    get_ConsultaPedido: async ({ state, commit }) => {
      try {
        let ItemsCar = [];
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CargarPedidoJson",
              usuario: state.dataUser.Usuario,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              opc: 3,
              json: 1,
            },
          }
        );
        const { data } = respuesta
        const { ConsultaPedido } = data
        const { Pedido: dataPed, Items, Promocion, Transporte, Embalaje } = ConsultaPedido
        const Pedido = (dataPed)
          ? dataPed
          : [{ TotItem: 0 }]

        if (Items) {
          Items.forEach((x) => {
            ItemsCar.push({
              Codigo: x.Codigo,
              Nombre: x.Nombre,
              categoria: x.categoria,
              subcategoria: x.subcategoria,
              CodigoDiv: x.CodigoDiv,
              CodigoDep: x.CodigoDep,
              CategoriaDiv: x.CategoriaDiv,
              SubCategoria: x.SubCategoriaDiv,
              grupoprod: x["grupo-prod"],
              orden: x.orden,
              Cantidad: x.Cantidad,
              Contenido: x.Contenido,
              Precio: x.Precio,
              Descuento: x.Descuento,
              PrecioNeto: x.PrecioNeto,
              PrecioTot: x.PrecioTot,
              MontoDesc: x.MontoDesc,
              MontoIVA: x.MontoIVA,
              PorcentIva: x.PorcentIva,
              PrecioNeto2: x.PrecioNeto2,
              ContentDetal: x.ContentDetal,
              ContentMayor: x.ContentMayor,
              UniVenta: x.UniVenta,
              PrecioTot2: x.PrecioTot2,
              Imagen: x.Imagen,
              Disponible: x.Disponible,
              Promo: x.Promo,
              TipoPaq: x.TipoPaq,
              Tipo: x.Tipo,
              CantidadMin: x.CantidadMin,
              Paquetes: x.Paquetes,
              Promociones:
                (Promocion)
                  ? Promocion.filter((f) => f.Articulo === x.Codigo)
                  : [],
              IndPromo:
                (Promocion)
                  ? Promocion.filter((f) => f.Articulo === x.Codigo).length !==
                    0
                    ? true
                    : false
                  : false,
              CantCar: x.Cantidad,
              CantCmb: false,
            });
          });
        }

        commit("set_Pedido", {
          data: Pedido[0],
          items: ItemsCar,
          promocion: Promocion,
          transporte: Transporte,
          embalaje: Embalaje,
        });
      } catch (error) {
        console.log(error);
      }
    },
    set_cargaArtCarrito: async ({ state, dispatch, commit }, param) => {
      commit("set_loading", true);
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CargarPedidoJson",
              articulo: param.articulo,
              cantidad: param.cantidad,
              promo: param.promo,
              usuario: state.dataUser.Usuario,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              opc: 0,
              json: 1,
            },
          }
        );
        const data = await respuesta.data;
        const { StatusJSon } = data;
        const [resValues] = StatusJSon || [];
        const { Procesado, Notas } = resValues || {};

        if(Procesado){
          await dispatch("get_ConsultaPedido");
        }
        
        commit("set_mensaje", {
          Visible: Procesado,
          Msj: Notas,
          Type: Procesado ? "success" : "error",
        });
      } catch (error) {
        console.log(error);
      } finally {
        commit("set_loading", false);
      }
    },
    set_updateArtCarrito: async ({ state, dispatch, commit }, param) => {
      commit("set_loading", true);
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CargarPedidoJson",
              vectorarticulo: param.articulo,
              vectorcantidad: param.cantidad,
              vectorpromo: param.promo,
              usuario: state.dataUser.Usuario,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              opc: 12,
              json: 1,
            },
          }
        );
        const data = await respuesta.data;
        const { StatusJSon } = data;
        const [resValues] = StatusJSon || [];
        const { Procesado, Notas } = resValues || {};

        if(Procesado){
          await dispatch("get_ConsultaPedido");
        }
        commit("set_mensaje", {
          Visible: true,
          Msj: Notas,
          Type: Procesado ? "success" : "error",
        });
       
      } catch (error) {
        console.log(error);
      }
      commit("set_loading", false);
    },
    set_eliminaArtCarrito: async ({ state, commit }, param) => {
      commit("set_loading", true);
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CargarPedidoJson",
              articulo: param.articulo,
              usuario: state.dataUser.Usuario,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              opc: 7,
              json: 1,
            },
          }
        );
        let data = await respuesta.data;
        const { StatusJSon } = data;
        const [resValues] = StatusJSon || [];
        const { Procesado, Notas } = resValues || {};
  
        commit("set_mensaje", {
          Visible: true,
          Msj: Notas,
          Type: Procesado ? "success" : "error",
        });
      } catch (error) {
       console.log(error);
      }finally {
        commit("set_loading", false);
      }
    },
    get_calculaCarrito: async ({ state, commit }) => {
      commit("set_loading", true);
      let Pedido = state.Pedido.data,
        itemsPed = state.Pedido.items;

      Pedido.MontoBruto = [0, 0];
      Pedido.MontoIva = [0, 0];
      itemsPed.forEach((x) => {
        Pedido.MontoBruto[0] += x.PrecioTot[0];
        Pedido.MontoBruto[1] += x.PrecioTot[1];
        Pedido.MontoIva[0] += x.MontoIVA[0];
        Pedido.MontoIva[1] += x.MontoIVA[1];
      });
      Pedido.MontoDes[0] = Pedido.MontoBruto[0] * (Pedido.Descuento / 100);
      Pedido.MontoDes[1] = Pedido.MontoBruto[1] * (Pedido.Descuento / 100);
      Pedido.MontoNeto[0] = Pedido.MontoBruto[0] - Pedido.MontoDes[0];
      Pedido.MontoNeto[1] = Pedido.MontoBruto[1] - Pedido.MontoDes[1];
      Pedido.MontoIva[0] = Pedido.MontoIva[0] * (1 - Pedido.Descuento / 100);
      Pedido.MontoIva[1] = Pedido.MontoIva[1] * (1 - Pedido.Descuento / 100);
      Pedido.MontoTotal[0] = Pedido.MontoNeto[0] + Pedido.MontoIva[0];
      Pedido.MontoTotal[1] = Pedido.MontoNeto[1] + Pedido.MontoIva[1];

      commit("set_Pedido", {
        data: Pedido,
        items: itemsPed,
        promocion: state.Pedido.promocion,
        transporte: state.Pedido.transporte,
        embalaje: state.Pedido.embalaje,
      });
      commit("set_loading", false);
    },
    async get_confirmarPedido({ state, dispatch, commit }, param) {
      commit("set_loading", true);
      try {
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CargarPedidoJson",
              usuario: state.dataUser.Usuario,
              cliente: state.Cliente.data.Codigo
                ? state.Cliente.data.Codigo
                : 0,
              opc: 10,
              json: 1,
              presupuesto: param.presupuesto1 ? 1 : 0,
              codigopromo: 0,
              transporte: param.transporte,
              refere: param.refere,
              observacion: param.notas,
            },
          }
        );

        let data = await respuesta.data;
        let wfpedido = await data.wfpedido;
        let NumOrden = await wfpedido.map((x) => x.Orden)[0];

        window.localStorage.setItem("datauser", JSON.stringify(state.dataUser));
        window.localStorage.setItem("cliente", JSON.stringify(state.Cliente));
        window.localStorage.setItem("tipoMoneda", this.tipoMoneda);

        setTimeout(() => {
          window.open(`${process.env.BASE_URL}pedidoconfirmado/${NumOrden}`, "_blank");
        }, 500);

        await dispatch("get_ConsultaPedido");
        this.$vuetify.goTo(0);
        this.$router.push("/");
      } catch (error) {
        console.log(error);
      }
      commit("set_loading", false);
    },
    get_pedidosPendientes: async ({ state, commit }) => {
      try {
        commit("set_Pendientes", []);
        let respuesta = await axios.get(
          `${state.dirPHP}${state.server_query}`,
          {
            params: {
              program: "CargarPedidoJson",
              usuario: state.dataUser.Usuario,
              opc: 4,
              json: 1,
            },
          }
        );
        let data = await respuesta.data;
        let ttcliente = await data.ttcliente;

        commit("set_Pendientes", ttcliente);
      } catch (error) {}
    },
  },
  modules: {
    mod_cliente,
    mod_agendaquery,
    mod_agendaset,
    mod_apiImg,
  },
});
